import React from 'react';

import receivingWarehouseMap from '@assets/img/arts/receiving-warehouse-map.svg';
import { Button } from '@components/Button';
import {
  ActionableDialog,
  ActionableDialogContent,
  ActionableDialogContentDivider,
  ActionableDialogTitle,
} from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '荷受倉庫を確認する',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  receivingWarehouseMapContainer: {
    ...common.flexCenter,
  },
  buttonContainer: {
    ...common.flexInline,
    ...common.justifyCenter,
    padding: '1rem',
  },
}));

export const CargosPortNameHelpersDialog: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <ActionableDialog open={open} onClose={onClose} size="lg">
      <ActionableDialogTitle>{strings.title}</ActionableDialogTitle>
      <ActionableDialogContent>
        <div className={classes.receivingWarehouseMapContainer}>
          <img alt="Receiving Warehouse Map" src={receivingWarehouseMap} width={693} height={447} />
        </div>
      </ActionableDialogContent>
      <ActionableDialogContentDivider />
      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          text={formStrings.confirm}
          size="small"
          data-testid="close-contact-filter"
          onClick={onClose}
          type="button"
        />
      </div>
    </ActionableDialog>
  );
};
